import { pgTable, uuid, text, timestamp } from "drizzle-orm/pg-core";

// Online withdrawal ("Atteikties no līguma") submissions from the returns
// page (Edgars spec 26.09.2026). Source of truth for the panelis list;
// the confirmation/notification emails are downstream best-effort.
export const withdrawalRequests = pgTable("withdrawal_requests", {
  id: uuid("id").primaryKey().defaultRandom(),
  fullName: text("full_name").notNull(),
  orderNumber: text("order_number").notNull(),
  email: text("email").notNull(),
  products: text("products").notNull(),
  reason: text("reason"),
  status: text("status").notNull().default("new"),
  createdAt: timestamp("created_at", { withTimezone: true }).notNull().defaultNow(),
  processedAt: timestamp("processed_at", { withTimezone: true }),
});

export type WithdrawalRequest = typeof withdrawalRequests.$inferSelect;
